<div mat-dialog-title class="dialog-info">
  <label class="dialogTitle">
    {{'TRR_DIALOG.TITLE' | translate}}
  </label>
  <button type="button" class="btn-close btn-close-white shadow-none dialogCross" [mat-dialog-close]></button>
</div>

<mat-dialog-content>
  <div class="trrDialogContent">
    <label class="dialogMessage dialog-message-padding" for="options">{{'TRR_DIALOG.TRR_APPROVED' | translate}}</label>
    <button mat-icon-button class="popover-button" data-bs-toggle="popover" aria-describedby="popover778357" 
    (mouseover)="initializePopover($event)" (mouseout)="destroyPopover($event)">
      <mat-icon >
        info_outline
      </mat-icon>
    </button>
    <mat-radio-group aria-label="Select an option" class="radio-group" [(ngModel)]="selectedRadioOption">
      <mat-radio-button color="primary" value="0">{{'COMMON_DIALOGS_BTN_LABELS.YES' | translate}}</mat-radio-button>
      <mat-radio-button color="primary" value="1">{{'COMMON_DIALOGS_BTN_LABELS.NO' | translate}}</mat-radio-button>
      <mat-radio-button color="primary" value="2">{{'COMMON_DIALOGS_BTN_LABELS.N/A' | translate}}</mat-radio-button>
    </mat-radio-group>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="dialogActionsBtns">
  <button class="openCloseBtn" mat-raised-button mat-dialog-close (click)="onOkClick()" color="primary">{{'COMMON_DIALOGS_BTN_LABELS.OK' | translate}}</button>
  <button class="openCloseBtn" mat-raised-button color="warn" (click)="onCancelClick()">{{'COMMON_DIALOGS_BTN_LABELS.CANCEL' | translate}}</button>
</mat-dialog-actions>